import dayjs from 'dayjs';

export function httpStringToDate(date: string): Date {
  return dayjs(date, 'YYYY-MM-DD').toDate();
}
